import { combineReducers } from 'redux';

import bulkRequest from './bulk-request/reducers';

const uiReducer = combineReducers({
  bulkRequest,
});

export default uiReducer;

export type UIState = ReturnType<typeof uiReducer>;
